<template>
  <div>
    <div class="top_banner">
      <img src="" alt="" />
    </div>
    <div class="info_word">
      <van-cell-group>
        <van-field
          label-width="3rem"
          label="现持有资金(元):"
          placeholder="请输入用户名"
        />
        <p
          style="
            text-align: right;
            font-size: 0.2rem;
            padding: 0.2rem 0.1rem 0.2rem 0;
          "
        >
          (包括现金、存款、有价证券和可以筹措到的资金总和)
        </p>
        <van-field
          label-width="3rem"
          label="现家庭月收入(元):"
          placeholder="请输入用户名"
        />
        <van-field
          label-width="3rem"
          label="家庭平均每月固定支出(元):"
          placeholder="请输入用户名"
        />
        <van-field
          label-width="3rem"
          label="您期望偿还贷款的年限:"
          placeholder="请输入用户名"
          readonly
          clickable
          @click="yearsPicker = true"
        />
        <van-popup v-model="yearsPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="yearsList"
            @confirm="yearsConfirm"
            @cancel="yearsPicker = false"
          />
        </van-popup>
        <van-field
          label-width="3rem"
          label="您计划购买房屋的面积(㎡):"
          placeholder="请输入用户名"
        />
      </van-cell-group>
    </div>
    <div class='btn'>
        <p>重置</p>
        <p>开始计算</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      yearsPicker: false,
      yearsList: [
        "1年",
        "2年",
        "3年",
        "4年",
        "5年",
        "6年",
        "7年",
        "8年",
        "9年",
        "10年",
        "11年",
        "12年",
        "13年",
        "14年",
        "15年",
        "16年",
        "17年",
        "18年",
        "19年",
        "20年",
        "21年",
        "22年",
        "23年",
        "24年",
        "25年",
        "26年",
        "27年",
        "28年",
        "29年",
        "30年",
      ],
    };
  },
  methods:{
      yearsConfirm(){

      }
  }
};
</script>
<style lang="less" scoped>
.info_word{
    margin-top:0.5rem;
}
.top_banner {
  position: relative;
  height: 4.64rem;
  img {
    height: 4.64rem;
    width: 100%;
  }
}
.btn{
    margin-top:1rem;
    padding-bottom: 1rem;
    display: flex;
    justify-content:space-around;
    p{
        width:1.8rem;
        padding:0.15rem 0;
        text-align: center;
        color: #fff;
        background: #007fff;
        border-radius: 5px;
    }
}
</style>